import React from "react";
import { InputWrapper } from "common/components/Wrapper/InputBase";
import { StyledInputBase } from "./TextInput";

export const TextInputWithoutValid = React.forwardRef(
  (
    {
      //InputWrapper
      label,
      caption,
      icon,

      //TextInput
      type = "text",
      pattern,
      placeholder,
      disabled,
      readOnly,
      value,
      onChange,
      forceError, // 외부에서 강제 에러 주기
      ...rest
    },
    ref,
  ) => {
    return (
      <InputWrapper
        label={label}
        caption={caption}
        icon={icon}
        error={forceError}>
        <StyledInputBase
          ref={ref}
          type={type}
          onChange={(e) => {
            const val = e.target.value;
            if (!pattern || pattern.test(val)) {
              onChange?.(val);
            }
          }}
          placeholder={readOnly ? undefined : disabled ? value : placeholder}
          value={value}
          disabled={disabled}
          readOnly={readOnly}
          iconPosition={icon?.position}
          $error={forceError} // 👈 여기 반영
          pattern={pattern?.source}
          {...rest}
        />
      </InputWrapper>
    );
  },
);
